export default __webpack_public_path__ + "static/media/gorro-policia.e377f94e.png";